import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { signInWithB2BByToken, useSignInAutoWithB2B } from "@lib/stores";
import { onLogin } from "@utils/helpers/nativeFunctions";

export const B2BAutoLoginByToken = () => {
  const [searchParams] = useSearchParams();

  const tokenSearchParam = searchParams.get("token");
  const languageId = searchParams.get("languageId") || 1;

  const { status } = useSignInAutoWithB2B();

  const signInB2bByToken = useCallback(async () => {
    if (tokenSearchParam) {
      signInWithB2BByToken({ token: tokenSearchParam }, (res) => {
        onLogin(JSON.stringify({ ...res, languageId }));
      });
    }
  }, [tokenSearchParam, languageId]);

  useEffect(() => {
    signInB2bByToken();
  }, [signInB2bByToken]);

  return (
    <div className="flex w-full items-center justify-center pt-40">
      {status === "loading" && (
        <Loader2
          className={`animate-spin text-white`}
          size={100}
          strokeWidth={1}
        />
      )}
    </div>
  );
};
